import { render, staticRenderFns } from "./CloseAppFooter.vue?vue&type=template&id=6e0dc693&scoped=true&"
import script from "./CloseAppFooter.vue?vue&type=script&lang=js&"
export * from "./CloseAppFooter.vue?vue&type=script&lang=js&"
import style0 from "./CloseAppFooter.vue?vue&type=style&index=0&id=6e0dc693&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dc693",
  null
  
)

export default component.exports